import React, { useEffect, useState } from "react";
import "../dashboard.scss";
import Select from "react-select";
import { academylist, createhostelvistor, detailhostelvistor } from "../../../services/admin";
import { vcategorylist } from "../../../services/master";
import moment from "moment";
import { toast } from "react-toastify";
import { useLocation, useNavigate, useParams } from "react-router-dom";

export default function Hostelvisitors() {
  const navigate = useNavigate();
  const { id } = useParams();
  const [alist, setAList] = useState([]);
  const [acaid, setAcaID] = useState("");


  const [vname, setVName] = useState("");
  const [vdate, setVDate] = useState("");
  const [vlist, setVList] = useState([]);
  const [vcat, setVCat] = useState("");
  const [mwith, setMWith] = useState("");
  const [vphone, setVPhone] = useState("");
  const [vintime, setVInTime] = useState("");
  const [vouttime, setVOutTime] = useState("");

  const [urllink, setUrl] = useState("");
  const location = useLocation();

  const [errorMessage, setErrorMessage] = useState("");
  useEffect(() => {
    const path = location.pathname.split("/")[2];
    setUrl(path);

    academylist().then((res) => {
      if (res.status === true) {
        let arr = [];
        if (res.data.details.length > 0) {
          for (let i = 0; i < res.data.details.length; i++) {
            arr.push({
              value: res.data.details[i].id,
              label:
                res.data.details[i].name + " - " + res.data.details[i].code,
            });
          }
          setAList(arr);
        }
      }
    });

    if (path === "hostelvisitorsdetail") {
      setVList([]);
      detailhostelvistor(id).then((res) => {
        if (res.status === true) {
          if (res.data.details !== null) {
            setVName(res.data.details.visitor_name);
            setVDate(moment(res.data.details.visitor_date).format("YYYY-MM-DD"));
            setVCat(res.data.details.visitor_type);
            setMWith(res.data.details.meeting_with);
            setVPhone(res.data.details.visitor_phone);
            setVInTime(res.data.details.visitor_intime);
            setVOutTime(res.data.details.visitor_outtime);
            academylist().then((res1) => {
              if (res1.status === true) {
                let arr = [];
                if (res1.data.details.length > 0) {
                  for (let i = 0; i < res1.data.details.length; i++) {
                    if (res1.data.details[i].id === res.data.details.academy_id) {
                      arr.push({
                        value: res1.data.details[i].id,
                        label:
                          res1.data.details[i].name +
                          " - " +
                          res1.data.details[i].code,
                      });
                    }
                  }
                  setAcaID(arr[0]);
                }
              }
            });
            const temp = new FormData();
            temp.append("academy_id", res.data.details.academy_id);
            vcategorylist(temp).then((res) => {
              if (res.status === true) {
                setVList(res.data);
              }
            });

          }
        }
      })
    } else {

      if (localStorage.getItem("ADate") !== '') {
        setVDate(moment(localStorage.getItem("ADate")).format("YYYY-MM-DD"));
      } else {
        setVDate(moment(new Date()).format("YYYY-MM-DD"));
      }
    }
    if (localStorage.getItem("AAcademy") != null) {
      academylist().then((res) => {
        if (res.status === true) {
          let arr = [];
          if (res.data.details.length > 0) {
            for (let i = 0; i < res.data.details.length; i++) {
              if (res.data.details[i].id == localStorage.getItem("AAcademy")) {
                arr.push({
                  value: res.data.details[i].id,
                  label:
                    res.data.details[i].name + " - " + res.data.details[i].code,
                });
              }
              if (arr.length > 0) {
                setAcaID(arr[0]);
                listcategory(arr[0]);
              }
            }
           
          }
        }
      });
    }else{
      listcategory("");
    }
  }, []);

  function handleAcademy(e) {
    if (e !== null) {
      setAcaID(e);
      listcategory(e);
    } else {
      setAcaID("");
      listcategory("");
    }
  }

  function listcategory(aid) {
    setVList([]);
    const temp = new FormData();
    if (localStorage.getItem("Role") === "1" && aid !== "") {
      temp.append("academy_id", aid.value);
    }
    vcategorylist(temp).then((res) => {
      if (res.status === true) {
        setVList(res.data);
      }
    });
  }

  function handlePhone(e) {
    const regex = /^[0-9\b]+$/;
    if (e.target.value === "" || regex.test(e.target.value)) {
      setVPhone(e.target.value);
    }
  }

  function handleSubmit(e) {
    e.preventDefault();
    setErrorMessage("");
    let valid = "";
    if (localStorage.getItem("Role") === "1" && acaid === "") {
      valid = "Please Select Academy";
      setErrorMessage(valid);
    } else {
      valid = "";
    }

    if (valid === "") {
      if (vname !== "") {
        if (vdate !== "") {
          if (vcat !== "") {
            if (mwith !== "") {
              if (vphone !== "") {
                if (vintime !== "") {
                  // if (vouttime !== "") {
                    const temp = new FormData();
                    temp.append("visitor_name", vname);
                    temp.append("visitor_phone", vphone);
                    temp.append("visitor_type", vcat);
                    temp.append("meeting_with", mwith);
                    temp.append("visitor_intime", vintime);
                    temp.append("visitor_outtime", vouttime);
                    temp.append("visitor_date", vdate);
                    if (localStorage.getItem("Role") === "1" && acaid !== "") {
                      temp.append("academy_id", acaid.value);
                    }
                    if (urllink === "hostelvisitorsdetail") {
                      temp.append("id", id);
                    }
                    createhostelvistor(temp).then((res) => {
                      if (res.status === true) {
                        toast.success(res.message);
                        navigate("/hostel/allhostelvisitors");
                      }
                    })
                  // } else {
                  //   setErrorMessage("Please Enter Out Time");
                  // }
                } else {
                  setErrorMessage("Please Enter In Time");
                }
              } else {
                setErrorMessage("Please Enter Phone Number");
              }
            } else {
              setErrorMessage("Please Select Meeting With");
            }
          } else {
            setErrorMessage("Please Select Visitor Category");
          }
        } else {
          setErrorMessage("Please Select Date");
        }
      } else {
        setErrorMessage("Please Enter Visitor Name");
      }
    }
  }

  const [loading, setLoading] = useState(false);

  return (
    <div>
      <div className="page-header">
        {urllink === "hostelvisitorsdetail" ?
          <div className="page-leftheader">
            <h2 className="main-content-title tx-24 mg-b-5">Hostel Visitors Detail</h2>
          </div>
          :
          <div className="page-leftheader">
            <h2 className="main-content-title tx-24 mg-b-5">Add Hostel Visitors</h2>
          </div>

        }
        <ol className="breadcrumb">
          <li className="breadcrumb-item"><a>Hostel Management</a></li>
          {urllink === "hostelvisitorsdetail" ? <li className="breadcrumb-item active" aria-current="page">Hostel Visitors Detail</li> : <li className="breadcrumb-item active" aria-current="page">Add Hostel Visitors</li>}
        </ol>
      </div>
      {loading && (
        <div className="loader-wrapper">
          <div className="loader"></div>
          <h3>Loading...Please do not go back or close the window.</h3>
        </div>
      )}
      {!loading &&
        <div className="content-body">
          <div className="container-fluid">
            <div className="card">
              <div className="card-body">
                <div className="row">
                  {localStorage.getItem("Role") === "1" &&
                    <div className="col-xl-6 col-sm-6">
                      <div className="mb-3">
                        <label className="form-label">
                          Academy<span className="text-danger"> *</span>
                        </label>
                        <Select
                          className="default-select"
                          placeholder="Select Academy"
                          value={acaid}
                          options={alist}
                          onChange={handleAcademy}
                          isSearchable={true}
                          isClearable
                          hidden
                        />
                      </div>
                    </div>
                  }

                  <div className="col-xl-6 col-sm-6">
                    <div className="mb-3">
                      <label className="form-label">
                        Name<span className="text-danger"> *</span>
                      </label>
                      <input
                        type="text"
                        className="form-control"
                        placeholder="Enter Visitor Name"
                        value={vname}
                        onChange={(e) => setVName(e.target.value)}
                      />
                    </div>
                  </div>
                  <div className="col-xl-6 col-sm-6">
                    <div className="mb-3">
                      <label className="form-label">
                        Date<span className="text-danger"> *</span>
                      </label>
                      <div className="input-group">
                        <input className="form-control" type="date" value={vdate} onChange={(e) => setVDate(e.target.value)} />
                      </div>
                    </div>
                  </div>
                  <div className="col-xl-6 col-sm-6">
                    <div className="mb-3">
                      <label className="form-label">
                        Visitor Category<span className="text-danger"> *</span>
                      </label>
                      <select className="default-select form-control wide" onChange={(e) => setVCat(e.target.value)} value={vcat}>
                        <option value="" disabled>Select Visitor Category</option>

                        {vlist.map((item) => {
                          return (
                            <option value={item.id}>{item.category}</option>
                          );
                        }
                        )}
                      </select>
                    </div>
                  </div>
                  <div className="col-xl-6 col-sm-6">
                    <div className="mb-3">
                      <label className="form-label">
                        Meeting With<span className="text-danger"> *</span>
                      </label>
                      <input
                        type="text"
                        className="form-control"
                        placeholder="Enter Meeting With"
                        value={mwith}
                        onChange={(e) => setMWith(e.target.value)}
                      />
                    </div>
                  </div>
                  <div className="col-xl-6 col-sm-6">
                    <div className="mb-3">
                      <label className="form-label">
                        Phone Number<span className="text-danger"> *</span>
                      </label>
                      <input
                        type="text"
                        className="form-control"
                        placeholder="Enter Phone Number"
                        maxLength={10}
                        value={vphone}
                        onChange={(e) => handlePhone(e)}
                      />
                    </div>
                  </div>
                  <div className="col-xl-6 col-sm-6">
                    <div className="mb-3">
                      <label className="form-label">
                        In Time<span className="text-danger"> *</span>
                      </label>
                      <input
                        type="text"
                        className="form-control"
                        placeholder="Enter In Time"
                        value={vintime}
                        onChange={(e) => setVInTime(e.target.value)}
                      />
                    </div>
                  </div>
                  <div className="col-xl-6 col-sm-6">
                    <div className="mb-3">
                      <label className="form-label">
                        Out Time
                        {/* <span className="text-danger"> *</span> */}
                      </label>
                      <input
                        type="text"
                        className="form-control"
                        placeholder="Enter Out Time"
                        value={vouttime}
                        onChange={(e) => setVOutTime(e.target.value)}
                      />
                    </div>
                  </div>
                </div>
                {errorMessage && <div className="text-danger">{errorMessage}</div>}
              </div>
            </div>


            <div className="res-right mt-2 me-4">
              <button className="btn btn-success me-2" onClick={handleSubmit}>Submit</button>
              {urllink === "hostelvisitorsdetail" ? <button className="btn btn-secondary" onClick={() => navigate("/hostel/allhostelvisitors")}>Cancel</button> : ""}
            </div>
          </div>
        </div>
      }

    </div>
  );
}
